<div class="override-panel">

  <div *ngIf="initialised" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="18px">

    <mat-form-field appearance="fill">
      <input [(ngModel)]="license.subscriptions['ait-lsp'].expiry" (ngModelChange)="handleExpireOverride($event)" matInput [matDatepicker]="picker">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <select [(ngModel)]="license.subscriptions['ait-lsp'].plan.name"  (ngModelChange)="handleTierOverride($event)"  matNativeControl required>
        <option value="paid">Paid</option>
        <option value="lapsed">Lapsed</option>
        <option value="trial">Trial</option>
        <option value="consultant">Consultant</option>
        <option value="unlicensed">Unlicensed</option>
      </select>
    </mat-form-field>

  </div>

</div>


